module.exports = __webpack_public_path__ + "static/media/puzzle-tw-min.d5ea3ef2.png";